export const UserStorageKey = 'pegUser';
